import { CustomFieldRenderProps, f0FormField } from '@factorialco/f0-react'
import { z } from 'zod'

import type useRichTextEditor from 'modules/core/hooks/useRichTextEditor'
import i18n from 'modules/core/lib/i18n'

import { RichTextOrTextArea } from './RichTextOrTextArea'

export function buildCommentsSchema({
  canUseRichTextEditor,
  richTextEditorLoading,
  editorConfig,
}: {
  canUseRichTextEditor: boolean
  richTextEditorLoading: boolean
  editorConfig: ReturnType<typeof useRichTextEditor>['editorConfig']
}) {
  return z.object({
    comments: f0FormField(z.string().optional(), {
      label: i18n.t('trainings.training_requests.create.additional_info.description'),
      fieldType: 'custom',
      render: ({ value, onChange }: CustomFieldRenderProps<string | undefined>) => (
        <RichTextOrTextArea
          value={value}
          onChange={onChange}
          canUseRichTextEditor={canUseRichTextEditor}
          richTextEditorLoading={richTextEditorLoading}
          editorConfig={editorConfig}
          label={i18n.t('trainings.training_requests.create.additional_info.description')}
          placeholder={i18n.t('trainings.training_requests.create.additional_info.placeholder')}
        />
      ),
    }),
  })
}

export const commentsSection = () => ({
  title: i18n.t('trainings.training_requests.create.additional_info.title'),
})

export const commentsDefaults = {}
